export const CURRENT_ENV = {
  APP_STAGE: process.env.REACT_APP_STAGE,
  API_URL: process.env.REACT_APP_API_URL,
  STORAGE_URL: process.env.REACT_APP_STORAGE_URL,
  PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL,
  IMG_URL: process.env.REACT_APP_IMG_URL,
  PREFIX_IMG: process.env.REACT_APP_PREFIX_IMG,
  APP_ROLE: process.env.REACT_APP_ROLE,
  WEB_URL: process.env.REACT_APP_WEB_URL
};
